// Nut und Falz — tiefenbegrenzte Bearbeitungen in part.meta.grooves. Engine-frei.
// Nut: Kanal in der Fläche, läuft komplett durch; direction "x" = parallel zur
//   Länge (Abstand ab vorderer Kante), "z" = parallel zur Breite (ab linker Kante).
//   offset_mm = Abstand Kante → Nutmitte (Werkstatt-Konvention wie bei Bohrungen).
// Falz: Stufe entlang einer Kante (l1/l2 = vorn/hinten, b1/b2 = links/rechts).
// side: "top"|"bottom" = Fläche, von der aus gearbeitet wird.

const MIN_WIDTH = 2
const MIN_DEPTH = 1
const EDGE = 1

export function groovesOf(part) {
  return part.meta?.grooves ?? []
}

export function withGrooves(part, grooves) {
  const meta = { ...part.meta }
  if (grooves.length > 0) meta.grooves = grooves
  else delete meta.grooves
  return meta
}

export function isFalz(groove) {
  return groove.type === "falz"
}

// Quermaß, in dem die Nut liegt (bzw. in das der Falz hineingreift)
export function crossDimension(groove, part) {
  if (isFalz(groove)) {
    return groove.edge?.startsWith("l") ? part.width_mm : part.length_mm
  }
  return groove.direction === "z" ? part.length_mm : part.width_mm
}

export function clampGroove(groove, part) {
  const side = groove.side === "bottom" ? "bottom" : "top"
  const depth_mm = Math.round(clamp(groove.depth_mm, MIN_DEPTH, part.thickness_mm - 1))

  if (isFalz(groove)) {
    const edge = [ "l1", "l2", "b1", "b2" ].includes(groove.edge) ? groove.edge : "l1"
    const maxWidth = crossDimension({ ...groove, edge }, part) - EDGE
    return {
      type: "falz",
      edge,
      side,
      width_mm: Math.round(clamp(groove.width_mm, MIN_WIDTH, maxWidth)),
      depth_mm
    }
  }

  const direction = groove.direction === "z" ? "z" : "x"
  const cross = crossDimension({ ...groove, direction, type: "nut" }, part)
  const width_mm = Math.round(clamp(groove.width_mm, MIN_WIDTH, cross - 2 * EDGE))
  return {
    type: "nut",
    direction,
    side,
    width_mm,
    depth_mm,
    offset_mm: Math.round(clamp(groove.offset_mm ?? cross / 2, width_mm / 2 + EDGE, cross - width_mm / 2 - EDGE))
  }
}

function clamp(value, min, max) {
  const number = Number.isFinite(value) ? value : min
  return Math.min(Math.max(number, min), Math.max(min, max))
}
